<template>
  <div class="clini-nutrit">
    <div class="nutrit-content padding-main mobile-padding">
      <el-row>
        <el-col :xs="24"
                :sm="24"
                :md="9"
                class="nutrit-desc">
          <div class="nutrit-title">{{ $t('cliniNutrit.cliniNutritMana') }}</div>
          <div class="nutrit-tip">{{ $t('cliniNutrit.cliniNutritManaTip') }}</div>
          <!-- <div class="nutrit-tip hidden-md-and-up">{{ $t('cliniNutrit.cliniNutritManaTip1') }}<span>{{ $t('cliniNutrit.cliniNutritManaTip2') }}</span></div> -->
          <el-button size="medium"
                     class="hidden-sm-and-down"
                     round
                     type="primary"
                     @click="jumpPage">{{ $t('home.cliniNutritSystem') }}<i class="el-icon-arrow-right" /></el-button>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="15"
                style="text-align: right;">
          <div class="image-flex">
            <el-image fit="cover"
                      class="hidden-sm-and-down"
                      src="/img/home-new_02.png" />
            <el-image fit="cover"
                      class="hidden-md-and-up"
                      src="/img/home-new_mobile.png" />
          </div>

        </el-col>
      </el-row>
    </div>
    <div class="system-features mobile-padding">
      <div class="title">
        {{ $t('cliniNutrit.systemFeatures') }}
      </div>
      <div class="mid-box hidden-sm-and-down">
        <div class="mid-center">
          <img src="/img/mid-center.png">
        </div>
        <div class="left-top tip-box">
          <img src="/img/left-top-icon.png">
          <div class="tip-title">{{ $t('cliniNutrit.seamlessDocking') }}</div>
          <div class="tip">{{ $t('cliniNutrit.seamlessDockingTip') }}</div>
        </div>
        <div class="left-mid tip-box">
          <img src="/img/left-bottom-icon.png">
          <div class="tip-title">{{ $t('cliniNutrit.easyUse') }}</div>
          <div class="tip">{{ $t('cliniNutrit.easyUseTip') }}</div>
        </div>
        <div class="left-bottom tip-box">
          <img src="/img/right-mid-icon.png">
          <div class="tip-title">{{ $t('cliniNutrit.supplyChainSystem') }}</div>
          <div class="tip">{{ $t('cliniNutrit.supplyChainSystemTip') }}</div>
        </div>
        <div class="right-top tip-box">
          <img src="/img/left-mid-icon.png">
          <div class="tip-title">{{ $t('cliniNutrit.treatmentProcedures') }}</div>
          <div class="tip">{{ $t('cliniNutrit.treatmentProceduresTip') }}</div>
        </div>
        <div class="right-mid tip-box">
          <img src="/img/right-top-icon.png">
          <div class="tip-title">{{ $t('cliniNutrit.professionalMana') }}</div>
          <div class="tip">{{ $t('cliniNutrit.professionalManaTip') }}</div>
        </div>
        <div class="right-bottom tip-box">
          <img src="/img/right-bottom-icon.png">
          <div class="tip-title">{{ $t('cliniNutrit.hospitalMana') }}</div>
          <div class="tip">{{ $t('cliniNutrit.hospitalManaTip') }}</div>
        </div>
      </div>
      <div class="mid-box-mobile hidden-md-and-up">
        <div class="left-top tip-box">
          <el-image fit="cover"
                    src="/img/left-top-icon.png" />
          <div class="mid-right">
            <div class="tip-title">{{ $t('cliniNutrit.seamlessDocking') }}</div>
            <div class="tip">{{ $t('cliniNutrit.seamlessDockingTip') }}</div>
          </div>
        </div>
        <div class="left-mid tip-box">
          <el-image fit="cover"
                    src="/img/left-mid-icon.png" />
          <div class="mid-right">
            <div class="tip-title">{{ $t('cliniNutrit.treatmentProcedures') }}</div>
            <div class="tip">{{ $t('cliniNutrit.treatmentProceduresTip') }}</div>
          </div>
        </div>
        <div class="left-bottom tip-box">
          <el-image fit="cover"
                    src="/img/left-bottom-icon.png" />
          <div class="mid-right">
            <div class="tip-title">{{ $t('cliniNutrit.easyUse') }}</div>
            <div class="tip">{{ $t('cliniNutrit.easyUseTip') }}</div>
          </div>
        </div>
        <div class="right-top tip-box">
          <el-image fit="cover"
                    src="/img/right-top-icon.png" />
          <div class="mid-right">
            <div class="tip-title">{{ $t('cliniNutrit.professionalMana') }}</div>
            <div class="tip">{{ $t('cliniNutrit.professionalManaTip') }}</div>
          </div>
        </div>
        <div class="right-mid tip-box">
          <el-image fit="cover"
                    src="/img/right-mid-icon.png" />
          <div class="mid-right">
            <div class="tip-title">{{ $t('cliniNutrit.supplyChainSystem') }}</div>
            <div class="tip">{{ $t('cliniNutrit.supplyChainSystemTip') }}</div>
          </div>
        </div>
        <div class="right-bottom tip-box">
          <el-image fit="cover"
                    src="/img/right-bottom-icon.png" />
          <div class="mid-right">
            <div class="tip-title">{{ $t('cliniNutrit.hospitalMana') }}</div>
            <div class="tip">{{ $t('cliniNutrit.hospitalManaTip') }}</div>
          </div>
        </div>
        <div class="mid-center">
          <el-image fit="cover"
                    src="/img/mid-center-mobile.png" />
        </div>
      </div>
    </div>
    <div class="main-function padding-main mobile-padding">
      <div class="list-name">
        {{ $t('cliniNutrit.mainFunction') }}
      </div>
      <div class="list">
        <div v-for="(item ,index) in funcList"
             :key="index"
             class="list-item">
          <el-image :src="vaildatePc()?item.icon:item.mobile_icon"
                    fit="cover" />
          <div class="item-title">{{ item.title }}</div>
          <div class="item-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="mobile-bottom" />
  </div>

</template>
<script>
import { vaildatePc } from '@/commonModule/utils/validate'
import { cliniNutritObj, loginBtnList } from '@/const/crud/list'

export default {
  name: 'CliniNutrit',
  data () {
    return {
      vaildatePc,
      funcList: cliniNutritObj.funcList,
      loginBtnList: loginBtnList
    }
  },
  methods: {
    jumpPage () {
      window.open(loginBtnList[1].list[0].url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixin.scss';

.image-flex {
  height: 100%;
  @include wrap-flex;
}

.el-row,
.el-col {
  height: 100%;
}

.title {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  margin-top: 3.125vw;
}
.clini-nutrit {
  .nutrit-content {
    background-color: $bgColor;
    height: 39.06vw;
    .nutrit-title {
      font-size: 44px;
      margin-top: 7.29vw;
      font-weight: bold;
      margin-bottom: 0.72vw;
    }
    .nutrit-tip {
      font-size: 18px;
      margin-bottom: 1.56vw;
    }
  }
  .system-features {
    height: 56.25vw;
    .mid-box {
      display: inline;

      .tip-box {
        width: 15%;
        position: absolute;
        text-align: center;
        z-index: 9;

        .tip {
          font-size: 16px;
          margin-top: 2%;
          color: #333333;
        }
        .tip-title {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          margin-top: 2%;
          margin-bottom: 1%;
        }
        img {
          width: 6.04vw;
          height: auto;
        }
      }
      .left-top {
        margin-top: -50%;
        margin-left: 17%;
      }
      .left-mid {
        margin-top: -30%;
        margin-left: 17%;
      }
      .left-bottom {
        margin-top: -10.5%;
        margin-left: 14.5%;
        width: 20%;
      }
      .right-top {
        margin-top: -50%;
        margin-left: 68%;
      }
      .right-mid {
        margin-left: 68%;
        margin-top: -30%;
      }
      .right-bottom {
        margin-left: 65.5%;
        margin-top: -10.5%;
        width: 20%;
      }
    }

    .mid-center {
      width: 45%;
      height: auto;
      padding-top: 3.96vw;
      padding-bottom: 7%;
      margin: auto;
      text-align: center;
    }
    .mid-center img {
      width: 100%;
      height: 100%;
    }
  }

  .main-function {
    padding: 3.125vw 18.75vw;
    width: 100%;
    height: 53vw;
    background: #f7fcfe;
    .list-name {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 5.83vw;
    }

    .list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .list-item {
        padding: 1.56vw 0.52vw;
        width: 14.58vw;
        height: 14.58vw;
        background-color: #fff;
        margin-bottom: 1.56vw;
        text-align: center;
        border: 1px solid #f7fcfe;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        // &:nth-child(2n-1) {
        //   margin-right: 1.56vw;
        // }
        .el-image {
          width: 4.58vw;
        }
        .item-title {
          font-size: 1.25vw;
          font-weight: bold;
          margin-top: 1.04vw;
          margin-bottom: 0.72vw;
        }
        .item-desc {
          font-size: 16px;
        }
      }
    }
  }

  .mobile-bottom {
    display: none;
  }
}

@media screen and (min-width: 992px) and (max-width: 1350px) {
  .main-function {
    .item-desc {
      font-size: 12px !important;
    }
  }
}

@media screen and (min-width: 1350px) and (max-width: 1440px) {
  .main-function {
    .item-desc {
      font-size: 14px !important;
    }
  }
}

@media screen and (min-width: 992px) and (max-width: 1440px) {
  .system-features {
    .tip {
      font-size: 14px !important;
    }
  }
}

@media screen and (max-width: 992px) {
  .el-col {
    height: auto;
  }
  .mobile-padding {
    height: auto !important;
    padding: 5.33vw $mobilePadding !important;
  }
  .clini-nutrit {
    .nutrit-content {
      height: auto;
      text-align: center;
      padding: 5.33vw 0 !important;
      .nutrit-desc {
        padding: 0 $mobilePadding;
        .nutrit-title {
          font-size: 4.27vw;
          margin-bottom: 0.72vw;
          font-size: bold;
        }
        .nutrit-tip {
          font-size: $mobileFontSize;
          margin-bottom: 8.53vw;
          span {
            color: $mainColor;
          }
        }
      }
    }
    .system-features {
      .title {
        font-size: 4.27vw;
        margin-bottom: 5.87vw;
      }
      .mid-box-mobile {
        .tip-box {
          display: flex;
          align-items: center;
          margin-bottom: 8vw;
          .mid-right {
            flex: 1;
            margin-left: 2.67vw;
            .tip-title {
              font-size: $mobileFontSize;
              font-weight: bold;
              margin-bottom: 1.34vw;
            }
            .tip {
              font-size: 3.2vw;
            }
          }
          .el-image {
            height: 18vw;
            width: 18vw;
          }
        }
        .mid-center {
          width: 100%;
        }
      }
    }
    .main-function {
      padding: 8vw 3.2vw;
      .list-name {
        font-size: 4.27vw;
        margin-bottom: 5.33vw;
      }
      .list {
        // display: block;
        .list-item {
          padding: 5.33vw 2.67vw;
          width: 45.33vw;
          height: 53.33vw;
          border: none;
          .el-image {
            width: 14.4vw;
            margin-bottom: 3.73vw;
          }
          .item-title {
            font-size: 4.27vw;
            margin-top: 0vw;
            margin-bottom: 1.33vw;
          }
          .item-desc {
            font-size: $mobileFontSize;
          }
        }
      }
    }
  }
}
</style>
